import { useTranslation } from 'react-i18next';
import { IssueStatuses } from 'src/features/issues/api/types/response/issue.response';
import { z } from 'zod';

const MAX_COMMENT_LENGTH = 8192;

export const useIssueStatusFormValidationSchema = () => {
  const { t } = useTranslation(['validation', 'issues']);

  const schema = z.object({
    status: z.enum(IssueStatuses, {
      required_error: t('validation:required'),
    }),
    comment: z
      .string()
      .max(
        MAX_COMMENT_LENGTH,
        t('validation:maxCharacters', { count: MAX_COMMENT_LENGTH }),
      )
      .optional(),
  });

  return schema;
};
